import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Sparkles, FileText, Gavel, BarChart3 } from 'lucide-react';
const roadmapItems = [{
  icon: FileText,
  title: 'Legal Notice Generator',
  desc: 'Auto-generate cease & desist letters'
}, {
  icon: Gavel,
  title: 'Takedown Automation',
  desc: 'One-click platform takedown requests'
}, {
  icon: BarChart3,
  title: 'IP Portfolio Analytics',
  desc: 'Advanced trademark insights & reporting'
}];
export function FutureSection() {
  return <section className="py-20 md:py-24 bg-indigo-950 text-white overflow-hidden relative" data-id="element-139">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-140"></div>

      {/* Animated Glow */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.3, 0.5, 0.3]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-indigo-500/30 blur-[100px] rounded-full pointer-events-none" data-id="element-141" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-143">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-900/50 border border-indigo-700 text-indigo-200 text-xs font-bold tracking-wider uppercase mb-8 backdrop-blur-sm" data-id="element-144">
            <Sparkles className="w-3 h-3" data-id="element-145" />
            Coming Soon
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 md:mb-8 leading-tight" data-id="element-146">
            The future of <br data-id="element-147" />
            <span className="text-indigo-400" data-id="element-148">IP enforcement</span>
          </h2>

          <p className="text-base md:text-lg text-indigo-200 mb-10 md:mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-149">
            We're building the complete operating system for trademark
            protection. Here's what's coming next:
          </p>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-150">
            {roadmapItems.map((item, i) => <motion.div key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} whileHover={{
            y: -5,
            transition: {
              duration: 0.2
            }
          }} className="bg-white/5 hover:bg-white/10 rounded-2xl p-6 border border-white/10 backdrop-blur-sm transition-all cursor-default" data-id="element-151">
                <div className="w-12 h-12 bg-indigo-500/20 rounded-xl flex items-center justify-center mb-4 mx-auto" data-id="element-152">
                  <item.icon className="w-6 h-6 text-indigo-300" data-id="element-153" />
                </div>
                <h3 className="font-bold text-white mb-2" data-id="element-154">{item.title}</h3>
                <p className="text-sm text-indigo-200/80" data-id="element-155">{item.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}